import { createContext, useContext } from 'react';
import useMediaQuery from '@/hooks/useMediaQuery';

export const SplitPaneContext = createContext(false);

export const useInSplitPane = () => useContext(SplitPaneContext);

export const useBottomSpace = (hasBottomBar: boolean) => (useInSplitPane() || !hasBottomBar ? 'pb-10' : 'pb-44');

export const useIsDesktop = () => useMediaQuery('(min-width: 768px)');
